import es from "./es.json";
import gb from "./en.json";
import cat from "./es-ca.json";

export const defaultLocale = "gb";

export const languages = {
  es: es,
  gb: gb,
  "es-ca": cat
};

export const languageList = [
  {
    key: "es",
    value: "ES_LANGUAGE"
  },
  {
    key: "gb",
    value: "EN_LANGUAGE"
  },
  {
    key: "es-ca",
    value: "ES_CA_LANGUAGE"
  }
];
